// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "src/assets/js/" + chunkId + "." + {"90":"9caa4fee","156":"7b3b4fea","246":"13daf1f8","465":"77961407","751":"7a385eb9","861":"f15d0284","870":"5fad6993","956":"a873946d"}[chunkId] + ".js";
};